import React, { useEffect, useState } from "react";
import { makeSideBarActive } from "../../utils/ellowutils";
import * as CONSTANTS from "../../utils/CONSTANTS";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import Styles from "./styles.module.scss";
import crownIcon from "../../assets/images/crown_icon_fill.svg";
import { TabStrip, TabStripSelectEventArguments } from "@progress/kendo-react-layout";
import Tab from "../../compopnents/tab";
import ActivePositions from "./activepositions";
import { getPositions } from "./services";
import { viewedpageMixpanel } from "../../utils/mixpanel";

function Positions() {

  const loginId = localStorage.getItem('loginId')
  const customerId = localStorage.getItem('customerId')

  const [selected, setSelected] = useState<number>(0);
  const [positions, setPositions] = useState<any>()
  const [draft, setDraft] = useState<any>()
  const [closed, setClosed] = useState<any>()
  const [activeTotal, setActiveTotal] = useState<number>()
  const [totalActivePositions, setTotalActivePositions] = useState<number>()
  const [closedTotal, setClosedTotal] = useState<number>()
  const [draftTotal, setDraftTotal] = useState<number>()

  const BreadcrumsValues = ["Positions"];
 

  useEffect(() => {
    
    getAllPositions("active", 1, 25, "");
    getAllPositions("myPosition", 1, 25, "");
    getAllPositions("closed", 1, 25, "");
    getAllPositions("draft", 1, 25, "");
    viewedpageMixpanel();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getAllPositions = ( positionType: string,
    pageNumber: number,
    pageSize: number,
    searchValue: string,
    filters?: any) => {

      let data = {};
    
      if(filters){ 
        data = {
          positionType: positionType,
          login_id: loginId,
          filters: {
            companyId: customerId,
            filters
          }
        }
       }else{
        data = {
          positionType: positionType,
          login_id: loginId,
          filters: {
            companyId: customerId
          }
        }
       }
    
    getPositions(searchValue, pageNumber, pageSize, data).then((resp) => {
      
      if (resp && resp.status === 1) {  
        switch(positionType){
          case 'active':
            setPositions(resp.data)     
            setActiveTotal(resp.totalPositionsCountWithFilter)
            if(filters){      
              setTotalActivePositions(resp.totalPositionsCountWithFilter)
            }else{
              setTotalActivePositions(resp.totalActivePositionsCountWithoutFilters)
            }
            break;
          case "myPosition":
            break;
          case "closed":
            setClosed(resp.data);
            setClosedTotal(resp.totalPositionsCountWithFilter);
            break;
          case "draft":
            setDraft(resp.data);
            setDraftTotal(resp.totalPositionsCountWithFilter);
            break;
        }
      }
      
         
    })
    
  }
  
  const searchChange = (e: string) => {
    getAllPositions("active", 1, 25, e);
    getAllPositions("myPosition", 1, 25, e);
    getAllPositions("closed", 1, 25, e);
    getAllPositions("draft", 1, 25, e);
  };

  
  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 1);

  const ActiveTab = <>Active <i>{activeTotal}</i></>;
  const ClosedTab = <>Closed <i>{closedTotal}</i></>;
  const DraftTab = <>Draft <i>{draftTotal}</i></>;

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />
      <div className="dashboardContent">
        <DashboardHeader title={BreadcrumsValues} searchChange={searchChange} navigateTo="../createPositions" type="positions" />
        <section className={Styles.positionWrapper}>
          <div className={Styles.activePositions}>
            <img src={crownIcon} alt=""/>Active positions<span>{totalActivePositions}</span></div>          
            <TabStrip selected={selected} onSelect={handleSelect}>
              <Tab title={ActiveTab} >
                <ActivePositions positions={positions} />
              </Tab>
              <Tab title={ClosedTab}>
                <ActivePositions positions={closed} />
              </Tab>
              <Tab title={DraftTab}>
                <ActivePositions positions={draft} draftKey={'draftKey'}/>
              </Tab>
          </TabStrip>
        </section>
      </div>
    </section>
  );
}

export default Positions;
